export default "__VITE_ASSET__djnP5yRa__"